import privacyCenterHeaderSection from "blocks/headerSection/query";
import logoBadgeContentBlock from "blocks/logoBadgeContentBlock/query";
import privacyCenterQuoteContentBlock from "blocks/quoteContentBlock/query";
import {privacyCenterOurPrivacyApproachContentBlock, privacyCenterOurPrivacyApproachContentBlockItem} from "blocks/ourPrivacyApproachContentBlock/query";
import privacyCenterSecurityHighlightContentBlock from "blocks/securityHighlightContentBlock/query";
import {linkTo} from "../../querypieces";

const clubDataPrivacyCenterPageQuery = `
    ... on clubdataprivacycenterpage_Entry {
      id
      typeHandle
      title
      slug
      clubdataprivacycenterpagebuilder {
        ... on clubdataprivacycenterpagebuilder_richText_BlockType {
          id
          richText
          typeHandle
        }
        ... on clubdataprivacycenterpagebuilder_headerSection_BlockType {
${privacyCenterHeaderSection}
        }
        ... on clubdataprivacycenterpagebuilder_logoBadgeContentBlock_BlockType {
${logoBadgeContentBlock}
        }
        ... on clubdataprivacycenterpagebuilder_quoteContentBlock_BlockType {
${privacyCenterQuoteContentBlock}
        }
        ... on clubdataprivacycenterpagebuilder_ourPrivacyApproachContentBlock_BlockType {
${privacyCenterOurPrivacyApproachContentBlock}
          children {
            ... on clubdataprivacycenterpagebuilder_ourPrivacyApproachContentBlockItem_BlockType {
${privacyCenterOurPrivacyApproachContentBlockItem}
            }
          }
        }
        ... on clubdataprivacycenterpagebuilder_anchorLinks_BlockType {
          id
          children {
            ... on clubdataprivacycenterpagebuilder_anchorLink_BlockType {
              id
              anchorId
              typeHandle
              heading
            }
          }
          typeHandle
        }
        ... on clubdataprivacycenterpagebuilder_securityHighlightContentBlock_BlockType {
${privacyCenterSecurityHighlightContentBlock}
        }
        ... on clubdataprivacycenterpagebuilder_helpfulResourcesContentBlock_BlockType {
          id
          typeHandle
          heading
          children {
            ... on clubdataprivacycenterpagebuilder_helpfulResourcesContentBlockItem_BlockType {
              id
              typeHandle
${linkTo}
            }
          }
          anchorId
        }
        ... on clubdataprivacycenterpagebuilder_yourDataContentBlock_BlockType {
          id
          typeHandle
          heading
          children {
            ... on clubdataprivacycenterpagebuilder_yourDataContentBlockItem_BlockType {
              id
              heading
              image {
                url
                alt
                title
                ... on images_Asset {
                  id
                  optimized: optimizedImage {
                    placeholder: placeholderImage
                    srcset
                    srcsetWebp
                    focalPoint
                  }
                  altText
                  title
                  url
                }
              }
              typeHandle
              richText
            }
          }
          anchorId
        }
        ... on clubdataprivacycenterpagebuilder_dataPrivacyAddendumSection_BlockType {
          id
          typeHandle
          anchorId
          download {
            ... on downloads_Asset {
              id
              alt
              img
              srcset(sizes: "")
              title
              url
              uri
            }
          }
          richText
          typeHandle
          secondaryrichtext
          thirdRichText
          heading
          elementsList {
            ... on elementsListBlock_Entry {
              id
              code
              itemTitle
              message
              options
            }
          }
        }
      }
    }
`;
export default clubDataPrivacyCenterPageQuery;